import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import Swal from "sweetalert2";

import Button from "components/button";
import Input from "components/input";
import { NewPasswordData } from "types";
import { api } from "services/api";
import { autoCloseValidationMessage } from "utils/popUp";
import { toast } from "utils/toast";

interface NewPasswordFormProps {
  code: string;
  emailOrCpf: string;
}

const NewPasswordForm = ({ code, emailOrCpf }: NewPasswordFormProps) => {
  const schema = yup.object().shape({
    newPassword: yup
      .string()
      .required("*Campo obrigatório")
      .matches(
        RegExp(
          "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})(?=.*[!.@#$%^&*\"'¨()_+=`´{}~,<>;:?|\\]\\\\/[-])"
        ),
        "*Utilize letras maiúsculas e minúsculas, números e caracteres especiais (*#.!@)"
      ),
    newPasswordConfirm: yup
      .string()
      .required("*Campo obrigatório")
      .oneOf([yup.ref("newPassword")], "*As senhas não conferem"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<NewPasswordData>({ resolver: yupResolver(schema) });

  const onSubmit = async (data: NewPasswordData) => {
    Swal.showLoading();
    const body = { code, emailOrCpf, newPassword: data.newPassword };

    try {
      await api.post("/Auth/passwordReset", body);
      Swal.hideLoading();
      Swal.close();

      toast.fire({
        icon: "success",
        title: "Senha alterada com sucesso!",
      });
    } catch (error) {
      Swal.hideLoading();
      autoCloseValidationMessage(
        "Ocorreu um erro. Por favor, tente mais tarde.",
        5000
      );
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="px-2">
      <Input
        register={register("newPassword")}
        error={errors?.newPassword?.message}
        type="password"
        label="Digite a nova senha:"
        placeholder="Senha"
        autoFocus
        isInputPassword
        isPasswordRegistration
      />
      <Input
        register={register("newPasswordConfirm")}
        error={errors?.newPasswordConfirm?.message}
        type="password"
        label="Repetir nova senha:"
        placeholder="Senha"
        isInputPassword
      />

      <Button type="submit" blueSchema className="btn-lg w-100 mt-3">
        Salvar senha
      </Button>
    </form>
  );
};

export default NewPasswordForm;
